/* ============================================================
   Kaynaturalz — Product Page (PDP) interactions (Shopify build)
   Gallery thumbs, purchase options, accordions, sticky add bar.
   Add-to-bag goes straight to the real Shopify cart via the
   shared window.KNCart API exposed by kn-design-app.js.
   ============================================================ */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var money = function (n) { return "$" + n.toFixed(2); };

  /* ---------- marquee: duplicate for seamless loop ---------- */
  var mq = $("#mq");
  if (mq) mq.innerHTML += mq.innerHTML;

  /* ---------- gallery thumbnails ---------- */
  var thumbs = $("#thumbs"), mainImg = $("#mainImg");
  if (thumbs && mainImg) {
    thumbs.addEventListener("click", function (e) {
      var b = e.target.closest(".thumb");
      if (!b) return;
      thumbs.querySelectorAll(".thumb").forEach(function (t) { t.classList.remove("is-on"); });
      b.classList.add("is-on");
      var img = b.querySelector("img");
      if (img) {
        mainImg.src = img.getAttribute("data-full") || img.src;
        if (img.getAttribute("data-fit") === "contain") mainImg.classList.add("contain");
        else mainImg.classList.remove("contain");
      }
    });
  }

  /* ---------- purchase options (real Shopify variants) ---------- */
  var opts = $("#opts");
  var addBtn = $("#addBtn");
  var stickyPrice = $("#stickyPrice");
  var priceNow = $("#priceNow");
  var priceWas = $("#priceWas");
  var state = { variantId: null, price: 14.99, compare: 23.0, label: "1 Bar" };

  function readOpt(o) {
    state.variantId = parseInt(o.getAttribute("data-variant"), 10) || null;
    state.price = parseFloat(o.getAttribute("data-price"));
    state.compare = parseFloat(o.getAttribute("data-compare")) || null;
    state.label = o.getAttribute("data-label");
  }

  // Preserve any rating suffix (e.g. " · ★ 4.9") baked into the sticky bar by Liquid.
  var stickySuffix = "";
  if (stickyPrice) {
    var _idx = stickyPrice.textContent.indexOf("·");
    if (_idx >= 0) stickySuffix = " " + stickyPrice.textContent.slice(_idx);
  }

  function syncPrice() {
    if (priceNow) priceNow.textContent = money(state.price);
    if (priceWas) {
      if (state.compare && state.compare > state.price) { priceWas.textContent = money(state.compare); priceWas.hidden = false; }
      else { priceWas.hidden = true; }
    }
    if (addBtn && !addBtn.classList.contains("added")) addBtn.textContent = "Add to Bag — " + money(state.price);
    if (stickyPrice) stickyPrice.textContent = money(state.price) + stickySuffix;
  }

  if (opts && opts.querySelector(".opt")) {
    var initial = opts.querySelector(".opt.is-on") || opts.querySelector(".opt");
    if (initial) readOpt(initial);
    opts.addEventListener("click", function (e) {
      var o = e.target.closest(".opt");
      if (!o) return;
      opts.querySelectorAll(".opt").forEach(function (x) { x.classList.remove("is-on"); });
      o.classList.add("is-on");
      readOpt(o);
      syncPrice();
    });
  } else if (addBtn && addBtn.getAttribute("data-sv")) {
    // Single-variant product: read the variant straight off the Add button.
    state.variantId = parseInt(addBtn.getAttribute("data-sv"), 10) || null;
    state.price = parseFloat(addBtn.getAttribute("data-sv-price"));
    state.compare = parseFloat(addBtn.getAttribute("data-sv-compare")) || null;
  }
  syncPrice();

  /* ---------- quantity stepper (if present) ---------- */
  var qty = $("#qty");
  function getQty() { return Math.max(1, parseInt(qty && qty.value, 10) || 1); }
  if (qty) {
    $("#qMinus").addEventListener("click", function () { qty.value = Math.max(1, getQty() - 1); });
    $("#qPlus").addEventListener("click", function () { qty.value = getQty() + 1; });
    qty.addEventListener("change", function () { qty.value = getQty(); });
  }

  /* ---------- add to bag (real cart) ---------- */
  function addToBag(btn, restoreLabel) {
    if (!state.variantId || !window.KNCart) return;
    var orig = restoreLabel || (btn && btn.textContent);
    window.KNCart.add(state.variantId, getQty()).then(function () {
      if (btn) {
        btn.classList.add("added");
        btn.textContent = "✓ Added to Bag";
        setTimeout(function () { btn.classList.remove("added"); btn.textContent = orig; syncPrice(); }, 1500);
      }
      window.KNCart.open();
    }).catch(function (e) {
      if (btn) {
        btn.textContent = (e && e.description) ? "Sold out — restocking soon" : "Try again";
        setTimeout(function () { btn.textContent = orig; syncPrice(); }, 2000);
      }
    });
  }
  if (addBtn) addBtn.addEventListener("click", function () { addToBag(addBtn, "Add to Bag — " + money(state.price)); });
  var addBtnSticky = $("#addBtnSticky");
  if (addBtnSticky) addBtnSticky.addEventListener("click", function () { addToBag(addBtnSticky, "Add to Bag"); });

  /* ---------- accordions ---------- */
  var acc = $("#acc");
  if (acc) {
    acc.addEventListener("click", function (e) {
      var h = e.target.closest(".acc__head");
      if (!h) return;
      var item = h.parentElement, panel = h.nextElementSibling;
      if (item.classList.contains("is-open")) {
        item.classList.remove("is-open"); panel.style.maxHeight = null;
      } else {
        item.classList.add("is-open"); panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
    acc.querySelectorAll(".acc__item.is-open .acc__panel").forEach(function (p) {
      p.style.maxHeight = p.scrollHeight + "px";
    });
  }

  /* ---------- reveal safety net ---------- */
  (function () {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    function settle(el) {
      el.classList.add("in");
      setTimeout(function () {
        el.style.transition = "none";
        el.style.opacity = "1";
        el.style.transform = "none";
      }, 850);
    }
    if ("IntersectionObserver" in window) {
      var ro = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { settle(en.target); ro.unobserve(en.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (e) { ro.observe(e); });
      window.addEventListener("load", function () {
        setTimeout(function () { els.forEach(settle); }, 1500);
      });
    } else {
      els.forEach(settle);
    }
  })();

  /* ---------- sticky add bar ---------- */
  var addBox = $(".buy__actions"), sbar = $("#stickybar");
  if (addBox && sbar && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (en) {
      var e = en[0];
      sbar.classList.toggle("is-on", !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(addBox);
  }
})();
